module.exports = __webpack_public_path__ + "static/media/speaker-yean-mobile.f2b9f645.jpg";